import { PersonType } from '../../types';
export var list = [
    PersonType.INDIVIDUAL,
    PersonType.JOINT,
    PersonType.INDIVISION,
    PersonType.DIVIDED,
    PersonType.FOR_MINORS,
    PersonType.MORAL,
];
